const ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
const BASE = 62;
new Map(ALPHABET.map((character, index) => [character, index]));
function encodeInteger(integer) {
  if (!Number.isInteger(integer)) {
    throw new TypeError(
      `Expected an integer, got \`${integer}\` (${typeof integer}).`
    );
  }
  if (integer < 0) {
    throw new TypeError("The integer must be non-negative.");
  }
  if (integer === 0) {
    return ALPHABET[0];
  }
  let encodedString = "";
  while (integer > 0) {
    encodedString = ALPHABET[integer % BASE] + encodedString;
    integer = Math.floor(integer / BASE);
  }
  return encodedString;
}
export {
  encodeInteger
};
